import { Component, Input } from '@angular/core';
import { SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';

@Component({
    selector: 'odq-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss', '../styles/subscription-forms.css'],
    standalone: false
})
export class WelcomeComponent{

  @Input() model:  SubscriptionFormViewModel;
  @Input() inactiveMemberForSubscription: boolean;
  constructor(){}
}